import React from 'react';

import DataTable, { EmptyState } from '../DataTable';

import { formatAmount, formatDateTime } from '../../utils';

// Row numbering is per-page (keyset pagination has no absolute page offset).
function PaymentTable(props) {
  const {
    rows,
    loading,
    onRowClick = () => {},
    card = true,
    footer,
    error,
    onRetry,
    page,
    total,
    onPageChange,
  } = props;

  return (
    <DataTable
      card={card}
      loading={loading}
      minWidth={860}
      footer={footer}
      page={page}
      total={total}
      onPageChange={onPageChange}
    >
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Due</th>
          <th>Paid</th>
          <th>Order ID</th>
          <th>Method</th>
          <th>Reference</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      {!loading && error ? (
        <EmptyState
          colSpan={8}
          icon={false}
          heading="Something went wrong"
          message={error}
          actionLabel="Retry"
          onAction={onRetry}
        />
      ) : (
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              onClick={() => onRowClick(row)}
              key={row.id}
              style={{ cursor: 'pointer' }}
            >
              <td>{loading ? '—' : rowIndex + 1}</td>
              <td>{formatAmount(row.amount_due)}</td>
              <td>{formatAmount(row.amount_paid)}</td>
              <td>{row.order_id}</td>
              <td>{row.method}</td>
              <td>{row.reference}</td>
              <td>{row.status}</td>
              <td>{formatDateTime(row.created_at)}</td>
            </tr>
          ))}
        </tbody>
      )}
    </DataTable>
  );
}

export default PaymentTable;
